<template>
  <ul class="user-notification-list">
    <li v-for="notification in notificationList" :key="notification.id">
      <a :href="notification.link" @click.prevent="onClickNotificationLink(notification)">
        <span class="font-weight-bold">{{notification.subject}}</span><br />
        <small>{{notification.createdAt | formatCalenderDate}}</small>
      </a>
    </li>
    <p v-if="!notificationList || notificationList.length == 0" class="text-muted font-italic text-center pt-3">
      No unread notifications
    </p>
  </ul>
</template>

<style scoped>
.user-notification-list {
  min-width: 300px;
  padding: 0px;
  font-size: 0.75rem;
  line-height: 1rem;
  list-style: none;
  margin: 0;
}
.user-notification-list > li {
  border-bottom: 1px solid #e7eaec;
  height: 48px;
  padding: 0;
}
.user-notification-list > li > a {
  border-radius: 3px;
  color: inherit;
  text-align: left;
  font-weight: normal;
  display: block;
  padding: 8px;
}
.user-notification-list > li > a:focus,
.user-notification-list > li > a:hover {
  color: #262626;
  text-decoration: none;
  background-color: #f5f5f5;
}
</style>

<script>
export default {
  name: 'UserNotificationList',
  props: {
    notificationList: Array
  },
  methods: {
    onClickNotificationLink(notification) {
      this.$emit('clickNotification', notification)
    }
  }
}
</script>